(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // var loadProductRecommendationsIntoSection = function () {
  //   // Look for an element with class 'product-recommendations'
  //   var productRecommendationsSection = document.querySelector('.new-product-recommendations');
  //   if (productRecommendationsSection === null) {
  //     return;
  //   }
  //   // Read product id from data attribute
  //   var productId = productRecommendationsSection.dataset.productId;
  //   // Read limit from data attribute
  //   var limit = productRecommendationsSection.dataset.limit;
  //   // Build request URL
  //   var requestUrl =
  //     '/recommendations/products?section_id=new-product-recommendations&limit=' + limit + '&product_id=' + productId;
  //   // Create request and submit it using Ajax
  //   var request = new XMLHttpRequest();
  //   request.open('GET', requestUrl);
  //   request.onload = function () {
  //     if (request.status >= 200 && request.status < 300) {
  //       var container = document.createElement('div');
  //       container.innerHTML = request.response;
  //       productRecommendationsSection.parentElement.innerHTML =
  //         container.querySelector('.new-product-recommendations').innerHTML;
  //       theme.runMultiCurrency();
  //       $(window).trigger('checkcaptionheights');
  //       theme.checkForRevealElements();
  //       // Shopify reviews app
  //       if (window.SPR && SPR.initDomEls && SPR.loadBadges) {
  //         SPR.initDomEls();
  //         SPR.loadBadges();
  //       }
  //     }
  //   };
  //   request.send();
  // };
  // // If your section has theme settings, the theme editor
  // // reloads the section as you edit those settings. When that happens, the
  // // recommendations need to be fetched again.
  // // See https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
  // document.addEventListener('shopify:section:load', function (event) {
  //   if (event.detail.sectionId === 'new-product-recommendations') {
  //     loadProductRecommendationsIntoSection();
  //   }
  // });
  // // Fetching the recommendations on page load
  // loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl =
      '/recommendations/products?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML =
          container.querySelector('.product-recommendations').innerHTML;
        theme.runMultiCurrency();
        $(window).trigger('checkcaptionheights');
        theme.checkForRevealElements();
        // Shopify reviews app
        if (window.SPR && SPR.initDomEls && SPR.loadBadges) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
